import React, { Suspense } from 'react';
import {
  Switch, Redirect, Route
} from 'react-router-dom';
import LoadingScreen from './LoadingScreen';
import { flattenTabs, routeTabs } from '../utils/routeTabs';
import { Tab } from '../types';

/*
{
  route: '/meow',
  layout: SomeComponent
  exact: true,
  component: SomeOtherComponent
}
 */

interface Props {
  routes: Tab[],
  defaultLayout?: React.FunctionComponent<any>,
  url: string,
  defaultComponentProps?: Record<string, any>,
}

const layout = ({ children }: { children: React.ReactNode }) => <>{children}</>;

function Routes({
  routes,

  defaultLayout = layout,

  defaultComponentProps,
  url
}: Props) {
  const DefaultLayout = defaultLayout;
  const routedRoutes = routeTabs(routes, url);
  const flattenedRoutes = flattenTabs(routedRoutes);
  const defaultRoute = flattenedRoutes.find((tab) => tab.route);

  return (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {flattenedRoutes.map(({
          route,
          exact,
          layout: Layout = DefaultLayout,
          component: Component,
          componentProps = {},
        }) => (
          <Route
            key={route}
            exact={exact}
            path={route}
            render={(routeComponentProps: any) => (
              <Layout rootUrl={url} {...componentProps} {...defaultComponentProps}>
                <Component
                  route={route}
                  rootUrl={url}
                  {...routeComponentProps}
                  {...componentProps}
                  {...defaultComponentProps}
                />
              </Layout>
            )}
          />
        ))}
        <Redirect to={defaultRoute && defaultRoute.route || '/'} />
      </Switch>
    </Suspense>
  );
}

export default Routes;
